import { render, staticRenderFns } from "./notificationDetailContent.vue?vue&type=template&id=6f5460b8"
import script from "./notificationDetailContent.vue?vue&type=script&lang=js"
export * from "./notificationDetailContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports